module.exports = __webpack_public_path__ + "static/media/Gilevich_NS.be744338.jpg";